import {Component, OnDestroy, OnInit, Input} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import * as fromStore from '../../_store';
import {Store} from '@ngrx/store';
import {INDRAEmergencyData} from '@ibe.models/pnr-data.indra.model.lib';
import * as _ from 'lodash';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {ValidatorsApp} from '@ibe.components/shared/_validators';
import * as fromGlobalStore from '@ibe/store/index';
import {take} from 'rxjs/operators';
import { Router } from '@angular/router';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
  selector: 'app-passenger-detail-emergency-contact',
  templateUrl: './passenger-detail-emergency-contact.component.html',
  styleUrls: ['./passenger-detail-emergency-contact.component.scss']
})
export class PassengerDetailEmergencyContactComponent implements OnInit, OnDestroy {
	
	@Input() displayValidationMessages: boolean = false;
	
	public form: FormGroup = this.fb.group({
		emName:  [null, [Validators.required, ValidatorsApp.no_whitespace, Validators.pattern('[a-zA-Z_ ]+'),   Validators.maxLength(51)]],
		emPrefix: [null, [Validators.required]],
		emPhone: [null, [Validators.required, Validators.pattern('[0-9]+'),  Validators.maxLength(11) ]],
		declined: [null],
		emCountry: [null, [Validators.required]]
	});

	public isBookingPaymentPage: boolean = false;
	public displayMode: 'view' | 'edit';

	private sub$: Subscription = new Subscription();
	private _hasChanges: BehaviorSubject<boolean> = new BehaviorSubject(false);

	public countryCodesCodeOpts = [];
	public countryCodesPrefixOpts = [];

	trackByFn(index: number, item: any): any {
		return index;
	}

	get formClassDisplayModeView(): string {
		return Object.is(this.displayMode, 'view') ? 'sidebar__form--view-only' : '';
	}

	get countryClassOnError(): string {
		return this.form.get('emCountry').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
	}

	get prefixClassOnError(): string {
		return this.form.get('emPrefix').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
	}

	get nameClassOnError(): string {
		return this.form.get('emName').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
	}

	get hasChanges(): Observable<boolean> {
		return this._hasChanges.asObservable();
	}

	get hasData(): boolean {
		return !_.isEmpty(this.form.value);
	}

	constructor(
		private fb: FormBuilder,
		private store: Store<fromStore.State>,
		private globalStore: Store<fromGlobalStore.State>,
		private router: Router,
		private ibeAdminService: INDRAIbeAdminService
	) { }

	ngOnInit() {
		
		if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) {
			this.isBookingPaymentPage = true;
		}
		
		this.sub$.add(
			this.store.select(fromStore.getSelectedEmergencyData)
				.subscribe((data: INDRAEmergencyData) => {
					this.fillFormWithStoreData(data);
			})
		);

		this.sub$.add(
			this.globalStore.select(fromGlobalStore.getSelectedCountryCodesOpts)
				.subscribe(data =>
					{
						if (data && data.length) {
							this.countryCodesCodeOpts = this.INDRA_getCountryCodesOptions(data);
						}
					})
		);

		this.sub$.add(
			this.globalStore.select(fromGlobalStore.getSelectedCountryCodesPrefixOpts)
				.subscribe(data => {
					if (data && data.length) {
						this.countryCodesPrefixOpts = this.INDRA_getCountryCodesOptionsPrefix(data);
					}
				})
		);

		this.form.valueChanges.subscribe(() => {
			this._hasChanges.next(true);
			this.store.dispatch(new fromStore.UpdateFormChangedAction({'updateEmergencyContact': true}));
		});

		this.sub$.add(
			this.form.get('declined').valueChanges.subscribe((newValue: boolean) => {
				if (newValue) {
					this.setFormValidatorsWhenDeclined();
				} else {
					this.setFormValidatorsWhenNotDeclined();
				}
			})
		);
		
		// dispatch by default since this is a required section
		this.store.dispatch(new fromStore.UpdateFormChangedAction({'updateEmergencyContact': true}));
	}

 	private fillFormWithStoreData(data: INDRAEmergencyData) {
		if (!_.isNil(data)) {
			this.form.patchValue(this.getFormObject(data), {emitEvent: false});
			this.displayMode = this.isBookingPaymentPage ? 'edit' : 'view';
		} else {
			this.displayMode = 'edit';
		}
		if (data && data.declined) {
			this.setFormValidatorsWhenDeclined();
		} else {
			this.setFormValidatorsWhenNotDeclined();
		}
	}

	private getFormObject(data: INDRAEmergencyData): any {
		return {
			...data,
			emName: !_.isNil(data.emSurname) ? ((data.emName || '') + ' ' + (data.emSurname || '')).trim() : (this.isBookingPaymentPage ? (data.emName || '').trim() : null),
			emPrefix: this.mapPrefixData(data.emPrefix)
		};
	}

	private mapPrefixData(emPrefix: string): string {
		if (!_.isNil(emPrefix)) {
			return Object.is('+', emPrefix.charAt(0)) ? emPrefix : '+' + emPrefix;
		} else {
			return null;
		}
	}

	private setFormValidatorsWhenDeclined() {
		this.form.get('emCountry').clearValidators();
		this.form.get('emName').clearValidators();
		this.form.get('emPrefix').clearValidators();
		this.form.get('emPhone').clearValidators();

		this.form.get('emCountry').updateValueAndValidity({emitEvent: false});
		this.form.get('emName').updateValueAndValidity({emitEvent: false});
		this.form.get('emPrefix').updateValueAndValidity({emitEvent: false});
		this.form.get('emPhone').updateValueAndValidity({emitEvent: false});


	}

	private setFormValidatorsWhenNotDeclined() {
		this.form.get('emCountry').setValidators([Validators.required]);
		this.form.get('emName').setValidators([Validators.required, ValidatorsApp.no_whitespace, Validators.pattern('[a-zA-Z_ ]+'), Validators.maxLength(51)]);
		this.form.get('emPrefix').setValidators(Validators.required);
		this.form.get('emPhone').setValidators([Validators.required, Validators.pattern('[0-9]+'), Validators.maxLength(11)]);

		this.form.get('emCountry').updateValueAndValidity({emitEvent: false});
		this.form.get('emName').updateValueAndValidity({emitEvent: false});
		this.form.get('emPrefix').updateValueAndValidity({emitEvent: false});
		this.form.get('emPhone').updateValueAndValidity({emitEvent: false});
	}

	INDRA_getCountryCodesOptions(countryCodes) {
		const options = countryCodes.map(item => ({
			value: item.value,
			text: this.INDRA_getTranslation(item.text)
		}));
		options.sort((a, b) => a.text.localeCompare(b.text));
		return options;
	}
	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	ngOnDestroy() {
		this.sub$.unsubscribe();
	}

	formEmergencyContactErrors(control: string) {
		const errors = [];
		if (Object.is(control, 'emName')) {
			if (this.form.controls[control].hasError('whitespace')
			|| this.form.controls[control].hasError('pattern')) {
				errors.push('bookingDetails.error.emergencyContactNameInvalid');
			}
			if (this.form.controls[control].hasError('required')) {
				errors.push('bookingDetails.error.emergencyContactNameRequired');
			}
			if (this.form.controls[control].hasError('maxlength')) {
				errors.push(`Emergency Contact name can't have more than 51 characters`);
			}
		}
		if (Object.is(control, 'emCountry')) {
			if (this.form.controls[control].hasError('required')) {
				errors.push('bookingDetails.error.emergencyContactCountryRequired');
			}
		}
		if (Object.is(control, 'emPrefix')) {
			if (this.form.controls[control].hasError('required')) {
				errors.push('bookingDetails.error.emergencyContactPhoneCountryCodeRequired');
			}
		}
		if (Object.is(control, 'emPhone')) {
			if (this.form.controls[control].hasError('pattern')) {
				errors.push('bookingDetails.error.emergencyContactPhoneNumberInvalid');
			}
			if (this.form.controls[control].hasError('required')) {
				errors.push('bookingDetails.error.emergencyContactPhoneNumberRequired');
			}
			if (this.form.controls[control].hasError('maxlength')) {
				errors.push(`Emergency Phone number can't have more than 11 digits`);
			}

		}
		return errors.join('; ');
	}

	cancelEdit() {
		this.store.select(fromStore.getSelectedEmergencyData)
			.pipe(take(1))
			.subscribe((data: INDRAEmergencyData) => {
				if (!_.isNil(data)) {
					this.form.reset(this.getFormObject(data), {emitEvent: false});
				} else {
					this.form.reset();
				}
			});

		this.store.dispatch(
			new fromStore.UpdateFormChangedAction({'updateEmergencyContact': false})
		);

		this.displayMode = 'view';

		this._hasChanges.next(false);
	}

	openEditForm() {
		this.displayMode = 'edit';
	}

	clearForm() {
		this.form.reset();
	}

	INDRA_getCountryCodesOptionsPrefix(countryCodes) {
		const options = countryCodes.map(item => ({
			value: item.value,
			text: this.INDRA_getTranslation(item.text) + ' ' + item.value
		}));
		options.sort((a, b) => a.text.localeCompare(b.text));
		return options;
	}
}
